module.exports = __webpack_public_path__ + "436f525a2494afcacd9967237b85da55.jpg";